"use client";
import { ButtonComponent } from "@/components";
import { IMAGES } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React from "react";

const PageNotFound = () => {
  const router = useRouter();
  return (
    <Stack
      direction={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      minHeight={"100vh"}
      px={{ xs: 2, sm: 3, md: 4 }}
      py={{ xs: 2, sm: 3 }}>
      <Stack alignItems={"center"} rowGap={2} maxWidth={"600px"} width="100%">
        <Typography
          variant="h5"
          align={"center"}
          fontWeight={600}
          mb={2}
          sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" } }}>
          Sorry, the page you are looking for does not exist.
        </Typography>
        <Image
          src={IMAGES.notFound}
          alt="Page Not Found"
          style={{ maxWidth: "100%", height: "auto" }}
        />
        <ButtonComponent
          buttonStyle={{
            my: 2,
            fontSize: "clamp(0.85rem, 2vw, 1rem)",
            maxWidth: "350px",
          }}
          onClick={() => router.replace("/")}>
          Return to Homepage
        </ButtonComponent>
      </Stack>
    </Stack>
  );
};

export default PageNotFound;
